import "./autonomy.css";

import autonomyImage from "../assets/autonomy.png";

import ubs from "../assets/ubs.png";
import nvidia from "../assets/nvidia.png";
import google from "../assets/google-white-logo.png";
import innovateuk from "../assets/innovate uk-white.png";
import mol from "../assets/mayor of london.png";
import msft from "../assets/microsoft-white.png";

const supporterLogos = [
  { name: "Mayor of London", src: mol },
  { name: "UBS", src: ubs },
  { name: "NVIDIA", src: nvidia },
  { name: "Google", src: google },
  { name: "Innovate UK", src: innovateuk },
  { name: "Microsoft", src: msft },
];

export default function Autonomy() {
  return (
    <section
      className="autonomy"
      style={{ backgroundImage: `url(${autonomyImage})` }}
    >
      <div className="autonomy-content">
        <p className="autonomy-kicker">
          AI SHARED BRAIN FOR AUTONOMOUS FLEETS
        </p>

        <h1 className="autonomy-title">
          <span className="autonomy-title-desktop">
            MAKE THE PHYSICAL WORLD
          </span>

          <span className="autonomy-title-desktop">
            UNDERSTANDABLE TO AI
          </span>

          <span className="autonomy-title-mobile">
            MAKE THE PHYSICAL
          </span>

          <span className="autonomy-title-mobile">
            WORLD UNDERSTANDABLE
          </span>

          <span className="autonomy-title-mobile">
            TO AI
          </span>
        </h1>

        <div className="autonomy-line" />

        <p className="autonomy-copy">
          An AI platform that connects with existing systems through a shared
          intelligent layer. Up to 20x ROI for operators.
        </p>

        <div className="autonomy-bottom">
          <p className="autonomy-subtitle">
            BUILT BY LEADERS FROM AMAZON, META, BMW GROUP AND OXFORD. SUPPORTED BY
          </p>

          <div className="autonomy-logo-carousel">
            <div className="autonomy-logo-track">
              {[...supporterLogos, ...supporterLogos].map((logo, index) => (
                <div
                  className="autonomy-logo-item"
                  key={`${logo.name}-${index}`}
                  aria-hidden={index >= supporterLogos.length}
                >
                  <img
                    src={logo.src}
                    alt={index < supporterLogos.length ? logo.name : ""}
                  />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}